import { ClassificationLevel } from '@sonar-software/sonar-core';
import { ClassificationSelector } from '@ui/tags';
import { getClosestTableBody } from '@lib/popups';

import React, { useCallback } from 'react';
import { useApplicationReference, useUpdateDataSecurityApp } from '@hooks';

export interface AppClassificationditorProps {
    applicationId: number;
}

export const AppClassificationCellEditor: React.FC<AppClassificationditorProps> = ({ applicationId }) => {
	const { request } = useUpdateDataSecurityApp();
	const { classification } = useApplicationReference(applicationId);

	const handleChange = useCallback((change: ClassificationLevel) => {
		request({
			applicationId,
			classification: change ?? null
		});
	}, [ applicationId, request ]);

	return (
		<ClassificationSelector
			getPopupContainer={ getClosestTableBody }
			isSpreadsheet
			onChange={ handleChange }
			value={ classification as ClassificationLevel } />
	);
};
